import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';

class RequestInstallModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'request-install-modal';
  }

  static get properties() {
    return {
      action: { type: Object },
    };
  }

  renderContents() {
    return html`
      <style>
        bn-modal#${this.id} {
          --modal-min-width: 50%;
          --modal-max-width: 50%;
          --modal-min-height: auto;
        }
      </style>
      <h3 slot="title">Request Installation</h3>
      <p>
        Submit a request to have a device installed on this bin.
      </p>
      <bn-action
        .href="${this.href}"
        actionname="generate-installation-request"
        successtext="Installation Requested"
        errortext="An error occurred when trying to request installation."
        submittext="Request Installation"
        suppressheader
        @response="${this._onResponse}"
      ></bn-action>
    `;
  }

  _onResponse(e) {
    this.close();
    this.dispatchEvent(new CustomEvent('response', { detail: e.detail }));
  }
}

window.customElements.define('request-install-modal', RequestInstallModal);
